import styled from 'styled-components';
import Typography from '@mui/material/Typography';

export const Heading = styled(Typography)`
  &.MuiTypography-root {
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 600;
    color: ${(props) => props.theme.palette.text.primary};

    &.mb-0 {
      margin-bottom: 0;
    }
  }
`;
